import React, { useState } from "react";
import {
	Modal,
	Button,
	List,
	Typography,
	Alert,
	Input,
	Image,
	Spin,
} from "antd";
import { sellBoostFetch } from "../../utlifyFunction";
import { toast } from "react-toastify";

const CompetitorSEOModal = ({ visible, onClose }) => {
	const [loading, setLoading] = useState(false);
	const [seoData, setSeoData] = useState([]);
	const [failedUrls, setFailedUrls] = useState([]);
	const [urlInput, setUrlInput] = useState("");

	const isValidUrl = (url) => {
		try {
			new URL(url);
			return true;
		} catch (_) {
			return false;
		}
	};

	const getCompetitorKeywordsService = async () => {
		const urls = urlInput
			.split(",")
			.map((url) => url.trim())
			.filter(Boolean);
		const validUrls = urls.filter(isValidUrl);
		const invalidUrls = urls.filter((url) => !isValidUrl(url));

		if (validUrls.length === 0) {
			toast.error("Please enter at least one valid URL.");
			return;
		}

		if (invalidUrls.length > 0) {
			toast.warning(`Ignored invalid URLs: ${invalidUrls.join(", ")}`);
		}

		try {
			setLoading(true);
			const response = await sellBoostFetch(
				"POST",
				"/user/getCompetitorKeywords",
				{
					competitorUrls: validUrls,
				}
			);

			if (response?.keywords) {
				setSeoData(response.keywords.competitorSeoData || []);
				setFailedUrls(response.keywords.failedUrls || []);
			}
		} catch (error) {
			console.error("Error fetching competitor SEO data:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title="Competitor SEO Insights"
			open={visible}
			onCancel={onClose}
			footer={null}
			width={700}
		>
			<Spin spinning={loading}>
				<Input.TextArea
					rows={3}
					placeholder="Enter competitor URLs, separated by commas. Example: https://example.com/product-1, https://example.com/product-2"
					value={urlInput}
					onChange={(e) => setUrlInput(e.target.value)}
					style={{ marginBottom: 10 }}
				/>

				<Button
					type="primary"
					loading={loading}
					onClick={getCompetitorKeywordsService}
				>
					Fetch SEO Data
				</Button>

				{seoData.length > 0 && (
					<List
						bordered
						dataSource={seoData}
						style={{ marginTop: 20 }}
						renderItem={(item) => (
							<List.Item
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
								}}
							>
								<Typography.Text strong>{item.url}</Typography.Text>
								{item.ogImage && (
									<Image
										src={item.ogImage}
										alt="Product Image"
										width={100}
										style={{ marginBottom: 10 }}
									/>
								)}
								<p>
									<strong>Title:</strong> {item.ogTitle || "N/A"}
								</p>
								<p>
									<strong>Description:</strong> {item.ogDescription || "N/A"}
								</p>
								<p>
									<strong>Meta Keywords:</strong> {item.metaKeywords || "N/A"}
								</p>
								<p>
									<strong>Meta Description:</strong>{" "}
									{item.metaDescription || "N/A"}
								</p>
							</List.Item>
						)}
					/>
				)}

				{failedUrls.length > 0 && (
					<Alert
						message="Failed to fetch SEO data for some URLs"
						description={failedUrls.map(({ url, error }) => (
							<p key={url}>
								❌ <strong>{url}</strong> - {error}
							</p>
						))}
						type="error"
						showIcon
						style={{ marginTop: 20 }}
					/>
				)}
			</Spin>
		</Modal>
	);
};

export default CompetitorSEOModal;
